export default {
  /**
   * Lỗi validate
   */
  Validate: 'VALIDATE',
};
